import { render, staticRenderFns } from "./LeftBtn.vue?vue&type=template&id=b2c8f500&scoped=true&"
import script from "./LeftBtn.vue?vue&type=script&lang=js&"
export * from "./LeftBtn.vue?vue&type=script&lang=js&"
import style0 from "./LeftBtn.vue?vue&type=style&index=0&id=b2c8f500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c8f500",
  null
  
)

export default component.exports